(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["suppdawg-guide-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const link = event.target.closest && event.target.closest('a[data-guide-product]');
  if (!link) return;
  const privacy = window.Shopify && window.Shopify.customerPrivacy;
  if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
  const analytics = window.Shopify && window.Shopify.analytics;
  if (!analytics || typeof analytics.publish !== 'function') return;
  try {
    Promise.resolve(analytics.publish('suppdawg:guide_product_click', {
      article_handle: link.dataset.guideOwner,
      product_handle: link.dataset.guideProduct,
      placement: 'answer_first_pilot'
    })).catch(function() {});
  } catch (error) {}
});
  } catch(e) { console.error(e); }
})();

})();
